__webpack_require__.p = "https://static.age.awaze.com/postbook-auth-mfe/56512cce600b6aaa9ea47740f6a3380e28cd804a/_next/";